module.exports = __webpack_public_path__ + "img/partner-new3.41a39e74.png";